<div class="quickview">
    <button class="quickview__close" type="button" appClick (click)="closeModal()">
        <app-icon name="cross-20" size="20"></app-icon>
    </button>

    <div class="row">
        <div class="col-md-4 col-sm-6 col-12 text-center selectable-element ml-1 mr-1 mb-2" *ngFor="let element of elements"
        (click)="selectElement(element)">
            <div style="height: 250px; width: 100%; padding: 10px;">
                <img [src]="element.img" style="width: 100%; height: 100%; object-fit: contain;">
            </div>
            <h6 class="mt-2">{{element.name}}</h6>
        </div>
    </div>
</div>